import { createIcon } from '../createIcon.tsx';

export const BoltIcon = createIcon('BoltIcon', <path d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" />);
